<form [formGroup]="operationsForm" *ngIf="connectionChangeConfig$ | async as config">
  <h2>Was soll bei ihrer Anschlussänderung ausgeführt werden?</h2>
  <form-row *ngIf="config.powerIncreaseField !== FieldConfigEnum.HIDDEN">
    <mat-checkbox [formControl]="operationsForm.controls.powerIncrease">
      Ich benötige eine
      {{
        config.area !== AllAreaEnum.Water && config.area !== AllAreaEnum.Heat
          ? 'Leistungserhöhung'
          : 'Leistungsanpassung'
      }}
    </mat-checkbox>
  </form-row>
  <form-row *ngIf="config.moveConnectionLineField !== FieldConfigEnum.HIDDEN">
    <mat-checkbox [formControl]="operationsForm.controls.moveConnectionLine">
      Ich benötige eine Verlegung der Anschlussleitung
    </mat-checkbox>
  </form-row>
  <form-row
    *ngIf="
      config.moveServiceEntranceBoxField !== FieldConfigEnum.HIDDEN && config.area === AllAreaEnum.Power
    ">
    <mat-checkbox [formControl]="operationsForm.controls.moveServiceEntranceBox">
      Ich benötige eine Verlegung des Hausanschlusskastens
    </mat-checkbox>
  </form-row>
</form>
